import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m10 0 .566 3.44a7.27 7.27 0 0 0 5.995 5.993L20 10l-3.44.566a7.27 7.27 0 0 0-5.993 5.995L10 20l-.567-3.44a7.27 7.27 0 0 0-5.994-5.993L0 10l3.44-.567A7.27 7.27 0 0 0 9.432 3.44z"
    }, null, -1)
  ]))]))
}
export default { render: render }